import React from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDSkeleton from '../../../shared/antd/ANTDSkeleton'
import { addressFormat } from '../../../utils'
import { dayJs } from '../../../utils/dayjs'
import { buildingIcon } from '../../../utils/icons'
import { isEqual, length, notEqual } from '../../../utils/javascript'

const BuildingDetailsView = ({ details, viewType, handleEquipmentList }) => {
  const { t } = useTranslations()
  const allDealers = details?.allDealerDetails
  const shownDealers =
    allDealers && length(allDealers) ? allDealers.slice(0, 3) : []
  const otherDealers =
    allDealers && length(allDealers) && length(allDealers) > 3
      ? allDealers.slice(3, length(allDealers))
      : []
  return (
    <div>
      <h3 className="mb-10">{t('user_Building')}</h3>
      <ANTDSkeleton loading={details?.loading} active avatar>
        <div className="d-flex mt-3">
          <img
            width="80"
            height="80"
            src={details?.buildingDetail?.buildingImage || buildingIcon}
            alt="BuildingIcon"
          />
          <div className="info-detail">
            <h4 className="text-underline primary-color">
              {t('dvz_BuildingInfo')}
            </h4>
            <li>- {details?.buildingDetail?.name}</li>
            <li>- {addressFormat(details?.buildingDetail)}</li>
          </div>
          <div className="mr-10 info-detail customer-detail">
            <h4 className="text-underline primary-color">
              {t('dvz_CustomerDetails')}
            </h4>
            <li>- {details?.customerDetails?.businessName}</li>
          </div>
          <div style={{ paddingLeft: 10 }} className="job-detail">
            <h4 className="text-underline primary-color">
              {t('dvz_LastJobDetails')}
            </h4>
            <div>
              <li>
                <b>{t('dvz_Time')}: </b>
                {dayJs(details?.lastJobDetails?.creationDate).format(
                  'YYYY/MM/DD',
                ) || '-'}
              </li>
              <li>
                <b>{t('user_Contractor')}: </b>
                {details?.lastJobDetails?.contractorInfo?.businessName || '-'}
              </li>
              {
                <li className="d-flex">
                  <b>{t('user_Dealer')}: </b>
                  <span>
                    {length(shownDealers)
                      ? shownDealers?.map((v, i) => (
                          <li key={i}>{`${v?.businessName}${
                            notEqual(length(shownDealers) - 1, i) ? ',' : ''
                          }`}</li>
                        ))
                      : '-'}
                  </span>
                </li>
              }
              <li className="primary-color">
                {length(otherDealers)
                  ? `...${length(otherDealers)} ${t('dvz_MoreDealerAttached')}`
                  : null}
              </li>
            </div>
          </div>
        </div>
      </ANTDSkeleton>

      {isEqual(viewType, 'map') ? (
        <div className="mt-15 text-start pl-10">
          <h4
            className="mb-0 text-underline cursor-pointer primary-color"
            onClick={() => handleEquipmentList({ details })}
          >
            {t('dvz_ViewEquipmentDetails')}
          </h4>
        </div>
      ) : null}
    </div>
  )
}

export default BuildingDetailsView
